const initialState = {
  force_login: false,
  access_token: {},
  user: {},
}
export default initialState
